<template>
  <div class="group-page">
    <solution-banner :dataSouce="banner" />
    <div class="section">
      <div class="section-box bg-w">
        <div class="section-con">
          <h3 class="title">数字化营销转型面临的挑战</h3>
          <solution-card :dataSouce="card" />
        </div>
      </div>
      <div class="section-box bg-b">
        <div class="section-con">
          <h3 class="title">一站式可视化场景营销解决方案</h3>
          <solution-panel :dataSouce="panel" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from "./components/Banner.vue";
import SolutionCard from "./components/Card.vue";
import SolutionPanel from "./components/Panel.vue";

export default {
  name: "SolutionProject",
  components: {
    SolutionBanner,
    SolutionCard,
    SolutionPanel,
  },
  data() {
    return {
      banner: [
        {
          image: "https://cdn.ideamake.cn/sw-pc/images/banner/banner-group-02.png",
          title: "一站式可视化场景营销解决方案",
          link: "/index",
        },
      ],
      card: [
        {
          title: "到访成本高",
          list: [
            "看房场景单一",
            "线下看房体验感差",
            "案场到访成本高",
          ],
          icon: "https://cdn.ideamake.cn/sw-pc/images/card-icon-04.png",
        },
        {
          title: "客户难触达",
          list: [
            "渠道绑架",
            "拓客无通路",
            "客户来源分散获客效率低",
          ],
          icon: "https://cdn.ideamake.cn/sw-pc/images/card-icon-05.png",
        },
        {
          title: "价值传递弱",
          list: [
            "内容呈现不完整",
            "价值传递不清晰",
            "呈现形式单一",
          ],
          icon: "https://cdn.ideamake.cn/sw-pc/images/card-icon-06.png",
        },
      ],
      panel: [
        {
          direction: "left",
          title: "展示系统",
          subtitle:
            "3D可视化场景营销",
          link: "/index",
          list: [
            "三维场景交互带来全新视觉体验 ",
            "助力开发商打造去营销化案场",
            "定制一站式可视化场景营销解决方案",
          ],
          image: "https://cdn.ideamake.cn/sw-pc/images/solution-08.png",
        },
        {
          direction: "right",
          title: "传播系统",
          subtitle: "移动端营销",
          link: "/index",
          list: [
            "连接移动传播端口 ",
            "微信、公众号、直播平台",
            "扩大拓客渠道，随时随地看房"
          ],
          image: "https://cdn.ideamake.cn/sw-pc/images/solution-07.png",
        },
        
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.group-page {
  width: 100%;
  height: 100%;
  .section {
    width: 100%;
    height: 100%;
   
   
    &-box {
      width: 100%;
      height: 100%;
      padding: 80px 0;
     &.bg-w{
        background: #F7F9FB;
      }
      &.bg-b{
        background: #FFF;
      }
      .section-con {
        width: 1200px;
        margin: 0 auto;
        text-align: center;
      }
      .title {
        font-size: 32px;
        font-weight: 500;
        color: #2d2e30;
        padding-bottom: 60px;
      }
      .subtitle {
        font-size: 16px;
        font-weight: 400;
        padding-bottom: 60px;
        color: #5a5c60;
      }
    }
  }
}

// 移动端布局
@import "@/views/solution/min-solution";
</style>